<p>cadastrar-plano-cargo-salario works!</p>
